/* Suppliers.tsx
	Page affichant la liste des fournisseurs
	Utilise TiersCrudCard filtré sur le type 'FOU'
*/

// Import React
import React from 'react';

// Import FontAwesome
import {
	faBox,
	faIndustry,
	faLocationDot,
	faPhone,
} from '@fortawesome/free-solid-svg-icons';

// Import Router
import { useNavigate } from 'react-router-dom';

// Import Feature
import { TiersCrudCard } from 'features/tiers';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import Communs
import { MainButton } from 'common';

// Suppliers page component
const Suppliers: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen bg-gray-100 p-6">
			{/* Titre de page */}
			<PageHeader
				icon={faIndustry}
				title="Fournisseurs"
				subtitle="Gérez les fournisseurs de votre entreprise"
			/>
			<TiersCrudCard tiersType="FOU" size="lg" hideReturn className="mt-6" />
			{/* Actions rapides vers les domaines liés aux fournisseurs */}
			<div className="max-w-6xl mx-auto flex justify-end gap-2 mt-4">
				<MainButton
					label="Adresses"
					onClick={() => navigate('/app/addresses')}
					size="lg"
					icon={faLocationDot}
				/>
				<MainButton
					label="Contacts"
					onClick={() => navigate('/app/contacts')}
					size="lg"
					icon={faPhone}
				/>
				<MainButton
					label="Commandes"
					onClick={() => navigate('/app/orders')}
					size="lg"
					icon={faBox}
				/>
			</div>
		</div>
	);
};

export default Suppliers;
